import { Button, InlineStack, Modal, Pagination, RadioButton, Text, BlockStack, Tooltip, Popover, ActionList, Spinner, Box, Tag } from '@shopify/polaris'
import { ShipmentMajor } from '@shopify/polaris-icons'
import React, { Dispatch, useCallback, useEffect, useState } from 'react'
import { DI, DIProps } from '../../../../Core'
import { amazon_regions } from '../../Onboarding/components/onboardinghelper';
import { print_optionsI } from './BuyShipping';
import { useTranslation } from 'react-i18next';
import { useDebounce } from '../../useDebounce';
import { error } from 'src/Actions';
interface PropsI extends DIProps {
  service_selected: { requestToken: string, rateId: string, options: print_optionsI[], row: any, error: boolean };
  setServiceSelected: Dispatch<React.SetStateAction<{ requestToken: string, rateId: string, options: print_optionsI[], row: any, error: boolean }>>;
  pckg_dimension: { length: string, width: string, height: string, unit: string, error: boolean };
  setPckg: Dispatch<React.SetStateAction<{ length: string, width: string, height: string, unit: string, error: boolean }>>;
  pckg_weigth: { value: string, unit: 'KILOGRAM', error: boolean }
  setPckgWeight: Dispatch<React.SetStateAction<{ value: string, unit: 'KILOGRAM', error: boolean }>>;
  ship_from: { name: string, email: string, phone: string, address_line_1: string, address_line_2: string, country: string, state: string, city: string, zip: string, error: boolean }
  setShipFrom: Dispatch<React.SetStateAction<{ name: string, email: string, phone: string, address_line_1: string, address_line_2: string, country: string, state: string, city: string, zip: string, error: boolean }>>;
  shipDate: { value: string, error: boolean }
  setShipDate: Dispatch<React.SetStateAction<{ value: string, error: boolean }>>;
  items: any[];
  setItems: Dispatch<React.SetStateAction<any[]>>;
  data: any,
  setselectedValueAddedServices: (temp: any) => void;
  setSelectedPrint: React.Dispatch<React.SetStateAction<{ value: string; error: boolean; }>>
  setSelectedPrintOrientation: React.Dispatch<React.SetStateAction<{ value: string; error: boolean; }>>
}

const ShippingServices = ({ service_selected, setServiceSelected, setselectedValueAddedServices, setSelectedPrint, setSelectedPrintOrientation, ...props }: PropsI) => {
  const { t } = useTranslation();
  const itemsPerPage = 5;
  const [totalPages, setTotalPages] = useState<number>(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [paginatedRows, setPaginatedRows] = useState([]);
  const [sortLabel, setSortLabel] = useState<string>("price_low_to_high");
  const [popup, setpopup] = useState(false);
  const toggleActive = useCallback(() => setpopup((popup) => !popup), []);
  const [openModal, setOpenModal] = useState(false);
  const [rows, setRows] = useState<any>([]);
  const [selectedOption, setOptionSelected] = useState(service_selected.rateId);
  const [loader, setLoader] = useState(false);
  const [pagination, setPagination] = useState(1);
  const [showMoreTags, setShowMoreTags] = useState(-1);
  const getRows = async () => {
    setServiceSelected(a => ({ ...a, error: false }))
    let hasError = false
    if (!props.pckg_dimension.length || !props.pckg_dimension.width || !props.pckg_dimension.height) {
      hasError = true
      props.setPckg(a => ({ ...a, error: true }))
    }
    if (!props.pckg_weigth.value || !props.pckg_weigth.unit) {
      hasError = true
      props.setPckgWeight(a => ({ ...a, error: true }))
    }
    if (!props.ship_from.name || !props.ship_from.address_line_1 || !props.ship_from.city || !props.ship_from.country || !props.ship_from.zip) {
      hasError = true
      props.setShipFrom(a => ({ ...a, error: true }))
    }
    if (props.shipDate.error) {
      hasError = true;
    }
    let error_item = false
    props.items.map((item: any, index) => {
      if (!item?.weight?.value) {
        props.setItems((a: any) => {
          a[index].weight = { ...a?.[index]?.weight, error: true }
          return [...a]
        })
        error_item = true
      }
    })
    if (hasError || error_item) return;

    setLoader(true);
    setOpenModal(false);
    setRows([]);
    setPagination(1);
    setServiceSelected(a => ({ ...a, requestToken: '' }))
    let shippedDate: any = new Date(props.shipDate.value);
    shippedDate.setHours(23);
    shippedDate.setMinutes(52);
    shippedDate.setSeconds(30);
    const body = {
      ...props.data,
      items: props.items.map((item: any) => {
        return { ...item, weight: { value: item?.weight?.value, unit: props?.pckg_weigth?.unit || 'KILOGRAM' } }
      }),
      packages: [{
        dimensions: { ...props.pckg_dimension },
        weight: { ...props.pckg_weigth }
      }],
      default_ship_from_address: { ...props.ship_from, postalCode: props.ship_from.zip },
      ...(props.shipDate.value ? { shipDate: new Date(shippedDate)?.toISOString()?.slice(0, -5) + 'Z' } : {})
    }
    props.di.POST('amazon/amazon-buy-shipping/getRates', body).then((response) => {
      if (response.success && response?.data) {
        setTotalPages(Math.ceil(response?.data?.rates?.length / itemsPerPage))
        setServiceSelected(a => ({ ...a, requestToken: response.data.requestToken }))
        setRows(response.data.rates)
        setOpenModal(a => !a);
      } else {
        props.error(t(response?.message) ?? t('Failed to get services'));
      }
      setLoader(false);
    })
  }

  useEffect(() => { setOptionSelected(service_selected.rateId) }, [service_selected])

  const sortOptions: { [key: string]: string } = {
    delivery_promise_latest: "Delivery Promise: Latest",
    delivery_promise_oldest: "Delivery Promise: Oldest",
    price_low_to_high: "Price: Low to High",
    price_high_to_low: "Price: High to Low"
  }

  const selectedRow = service_selected?.row ?? {}
  const label_generated = !!props.data?.shipping_services?.[0]?.label_generated;

  const popoveractivator = (
    <Button onClick={toggleActive} disclosure>
      {t("Sort By")}: {sortOptions[sortLabel]}
    </Button>
  );

  const sortData = (sortOption: string) => {
    setSortLabel(sortOption);
    toggleActive();
    setPagination(1);
  }

  const getLabel = (obj: any) => {
    return `${obj?.format} (${obj?.size?.length} X ${obj?.size?.width} ${obj?.size?.unit})`
  }

  useEffect(() => {
    // Set the loader to true when starting the operation
    setIsLoading(true);

    // Use setTimeout to simulate a delay of 500ms
    setTimeout(() => {
      // Step 1: Sort the rows based on the specified sortOrder
      const sortedRows = [...rows].sort((a, b) => {
        if (sortLabel === "delivery_promise_latest") {
          const dateA: any = new Date(a.promise.deliveryWindow.end);
          const dateB: any = new Date(b.promise.deliveryWindow.end);
          return dateB - dateA; // Sort by date descending (latest first)
        } else if (sortLabel === "delivery_promise_oldest") {
          const dateA: any = new Date(a.promise.deliveryWindow.end);
          const dateB: any = new Date(b.promise.deliveryWindow.end);
          return dateA - dateB; // Sort by date ascending (oldest first)
        } else if (sortLabel === "price_high_to_low") {
          return b.totalCharge.value - a.totalCharge.value; // Sort by charge descending (high to low)
        } else if (sortLabel === "price_low_to_high") {
          return a.totalCharge.value - b.totalCharge.value; // Sort by charge ascending (low to high)
        }
        return 0; // Default case if no sortOrder is specified
      });

      // Step 2: Apply pagination
      const startIndex = (pagination - 1) * itemsPerPage;
      const endIndex = pagination * itemsPerPage;
      const paginatedData: any = sortedRows.slice(startIndex, endIndex);

      // Set the paginated and sorted data
      setPaginatedRows(paginatedData);

      // Step 3: Set the loader to false when the operation completes
      setIsLoading(false);
    }, 500); // 500ms delay
  }, [rows, pagination, sortLabel]);
  const tagsData = ["Claims Protected", "OTDR Protected", "OTDR Protected 2", "OTDR Protected 3", "OTDR Protected 3"];
  return <>
    <Modal
      size="large"
      open={openModal}
      onClose={() => { setOpenModal(false) }}
      title={t("Available Shipping Services")}
      primaryAction={{
        content: t('Apply'),
        onAction: () => {
          setOpenModal(false);
          setServiceSelected(a => ({
            ...a,
            rateId: selectedOption,
            row: rows?.find((a: any) => a.rateId === selectedOption),
            options: rows?.find((a: any) => a.rateId === selectedOption)?.supportedDocumentSpecifications?.map((p: any) => ({ label: `${getLabel(p) ?? t('PDF')}`, value: `${getLabel(p) ?? t('PDF')}` })),
            availableValueAddedServiceGroups: rows?.find((a: any) => a.rateId === selectedOption)?.availableValueAddedServiceGroups
          }));
          setSelectedPrint({ value: "", error: false });
          setSelectedPrintOrientation({ value: "", error: false });
          let temp = rows?.find((a: any) => a.rateId === selectedOption)?.availableValueAddedServiceGroups?.filter((availableValueAddedServiceGroup: any) => availableValueAddedServiceGroup?.isRequired)?.map((doc: any) => {
            return { ...doc, valueAddedServices: {}, error: false }
          });
          setselectedValueAddedServices(temp ?? [])
        },
      }}
    >
      <Modal.Section>
        <BlockStack gap={"300"}>
          <InlineStack align='end'>
            <div className='custom-sort' style={{ flex: '0 0 auto' }}>
              <Popover
                active={popup}
                activator={popoveractivator}
                autofocusTarget="first-node"
                onClose={toggleActive}
              >
                <ActionList
                  actionRole="menuitem"
                  items={[
                    { content: t('Delivery Promise: Latest'), onAction: () => sortData('delivery_promise_latest') },
                    { content: t('Delivery Promise: Oldest'), onAction: () => sortData('delivery_promise_oldest') },
                    { content: t('Price: Low to High'), onAction: () => sortData('price_low_to_high') },
                    { content: t('Price: High to Low'), onAction: () => sortData('price_high_to_low') },
                  ]}
                />
              </Popover>
            </div>
          </InlineStack>
          {isLoading ? <InlineStack align='center'><Spinner /></InlineStack> : <div className="Custom__Shipment--Choice">
            <BlockStack inlineAlign='center'>
              {paginatedRows.map((row: any, index: number) => {
                let tagsData = row?.benefits?.includedBenefits ?? [];
                return row?.requiresAdditionalInputs ?
                  <Tooltip content={row?.requiresAdditionalInputs ? "This carrier requires additional inputs" : undefined}>
                    <RadioButton
                      key={index}
                      label={
                        <InlineStack gap="400" align='space-between'>
                          <div className='Custom__Shipment--Choice-line'>
                            <Box width='160px' maxWidth='160px'>
                              <BlockStack>
                                <Text variant="headingSm" as="p">
                                  {row?.serviceName ?? ''}
                                </Text>
                                <Text variant="bodyMd" as="p">
                                  Carrier Name: {row?.carrierName}
                                </Text>
                                <Text variant="bodyMd" as="p" tone='subdued'>
                                  {t("Carrier ID")}: {row?.carrierId ?? ''}
                                </Text>
                              </BlockStack>
                            </Box>
                          </div>
                          <div className='Custom__Shipment--Choice-line'>
                            <Box width={row?.promise?.pickupWindow?.start ? '200px' : "100px"} maxWidth='205px'>
                              <BlockStack gap="100">
                                <Text variant="headingSm" as="h6">
                                  {t(" Ship By:")}
                                </Text>
                                {row?.promise?.pickupWindow?.start ? <BlockStack gap="050">
                                  <Box maxWidth='200px'>
                                    <Text as="p" tone="success" fontWeight="regular">
                                      {row?.promise?.pickupWindow?.start && new Date(row?.promise?.pickupWindow?.start).toUTCString()}
                                    </Text>
                                  </Box>
                                  <Text as="span" tone="success" fontWeight="regular">
                                    to
                                  </Text>
                                  <Box maxWidth='200px'>
                                    <Text as="p" tone="success" fontWeight="regular">
                                      {row?.promise?.pickupWindow?.end && new Date(row?.promise?.pickupWindow?.end).toUTCString()}
                                    </Text>
                                  </Box>
                                </BlockStack> : "N/A"}
                              </BlockStack>
                            </Box>
                          </div>
                          <div className='Custom__Shipment--Choice-line'>
                            <Box width='200px' maxWidth='205px'>
                              <BlockStack gap="100">
                                <Text variant="headingSm" as="h6">
                                  {t("Deliver By")}:
                                </Text>
                                <BlockStack gap="050">
                                  <Box maxWidth='200px'>
                                    <Text as="p" tone="success" fontWeight="regular">
                                      {row?.promise?.deliveryWindow?.start && new Date(row?.promise?.deliveryWindow?.start).toUTCString()}
                                    </Text>
                                  </Box>
                                  <Text as="span" tone="success" fontWeight="regular">
                                    to
                                  </Text>
                                  <Box maxWidth='200px'>
                                    <Text as="p" tone="success" fontWeight="regular">
                                      {row?.promise?.deliveryWindow?.end && new Date(row?.promise?.deliveryWindow?.end).toUTCString()}
                                    </Text>
                                  </Box>
                                </BlockStack>
                              </BlockStack>
                            </Box>
                          </div>
                          <div className='Custom__Shipment--Choice-line'>
                            <BlockStack gap={"200"}>
                              <Text as='p' variant='headingSm'>Benefits:</Text>
                              <BlockStack gap={"200"}>
                                {tagsData.slice(0, 2).map((ele: string, ind: number) => {
                                  return (
                                    <Tag key={ind}>{ele}</Tag>
                                  )
                                })}
                                {tagsData.length > 2 && <Popover activator={<Tag onClick={() => setShowMoreTags((showMoreTags) => showMoreTags === index ? -1 : index)}>+{tagsData.length - 2} more</Tag>} active={showMoreTags === index} onClose={() => setShowMoreTags(-1)}>
                                  <Popover.Section>
                                    <BlockStack gap={"200"}>
                                      {tagsData.slice(2).map((ele: string, ind: number) => {
                                        return (
                                          <Tag key={ind}>{ele}</Tag>
                                        )
                                      })}
                                    </BlockStack>
                                  </Popover.Section>
                                </Popover>}
                              </BlockStack>
                            </BlockStack>
                          </div>
                          <Text variant="headingXl" as="h5">
                            {amazon_regions.find(a => a?.currency === row?.totalCharge?.unit)?.currency_symbol ?? ''}
                            {row?.totalCharge?.value}
                          </Text>
                        </InlineStack>
                      }
                      checked={selectedOption === (row?.rateId ?? '')}
                      id={`${index}`}
                      name={`${index}`}
                      onChange={() => { setOptionSelected(a => (row?.rateId ?? '')) }}
                      disabled={row?.requiresAdditionalInputs}
                    />
                  </Tooltip> : <RadioButton
                    key={index}
                    label={
                      <InlineStack gap="200" wrap={false} align='space-between'>
                        <div className='Custom__Shipment--Choice-line'>
                          <Box width='130px' maxWidth='130px'>
                            <BlockStack>
                              <Text variant="headingSm" as="p">
                                {row?.serviceName ?? ''}
                              </Text>
                              <Text variant="bodyMd" as="p">
                                Carrier Name: {row?.carrierName}
                              </Text>
                              <Text variant="bodyMd" as="p" tone='subdued'>
                                {t("Carrier ID")}: {row?.carrierId ?? ''}
                              </Text>
                            </BlockStack>
                          </Box>
                        </div>


                        <div className='Custom__Shipment--Choice-line'>
                          <Box width={'200px'} maxWidth='200px'>
                            <BlockStack gap="100">
                              <Text variant="headingSm" as="h6">
                                {t(" Ship By:")}
                              </Text>
                              {row?.promise?.pickupWindow?.start ? <BlockStack gap="050">
                                <Box maxWidth='200px'>
                                  <Text as="p" tone="success" fontWeight="regular">
                                    {row?.promise?.pickupWindow?.start && new Date(row?.promise?.pickupWindow?.start).toUTCString()}
                                  </Text>
                                </Box>
                                <Text as="span" tone="success" fontWeight="regular">
                                  to
                                </Text>
                                <Box maxWidth='200px'>
                                  <Text as="p" tone="success" fontWeight="regular">
                                    {row?.promise?.pickupWindow?.end && new Date(row?.promise?.pickupWindow?.end).toUTCString()}
                                  </Text>
                                </Box>
                              </BlockStack> :
                                <BlockStack gap="050">
                                  <Box maxWidth='200px'>
                                    <Text as="p" tone="success" fontWeight="regular">
                                      {props.shipDate?.value && new Date(props.shipDate?.value).toUTCString()}
                                    </Text>
                                  </Box>
                                  <Text as="span" tone="success" fontWeight="regular">
                                    to
                                  </Text>
                                  <Box maxWidth='200px'>
                                    <Text as="p" tone="success" fontWeight="regular">
                                      {props.shipDate?.value && new Date(props.shipDate?.value).toUTCString()}
                                    </Text>
                                  </Box>
                                </BlockStack>
                              }
                            </BlockStack>
                          </Box>
                        </div>


                        <div className='Custom__Shipment--Choice-line'>
                          <Box width='200px' maxWidth='205px'>
                            <BlockStack gap="100">
                              <Text variant="headingSm" as="h6">
                                {t("Deliver By")}:
                              </Text>
                              <BlockStack gap="050">
                                <Box maxWidth='200px'>
                                  <Text as="p" tone="success" fontWeight="regular">
                                    {row?.promise?.deliveryWindow?.start && new Date(row?.promise?.deliveryWindow?.start).toUTCString()}
                                  </Text>
                                </Box>
                                <Text as="span" tone="success" fontWeight="regular">
                                  to
                                </Text>
                                <Box maxWidth='200px'>
                                  <Text as="p" tone="success" fontWeight="regular">
                                    {row?.promise?.deliveryWindow?.end && new Date(row?.promise?.deliveryWindow?.end).toUTCString()}
                                  </Text>
                                </Box>
                              </BlockStack>
                            </BlockStack>
                          </Box>
                        </div>
                        <div className='Custom__Shipment--Choice-line'>
                          <BlockStack gap={"200"}>
                            <Text as='p' variant='headingSm'>Benefits:</Text>
                            <BlockStack gap={"200"}>
                              {tagsData.slice(0, 2).map((ele: string, ind: number) => {
                                return (
                                  <Tag key={ind}>{ele}</Tag>
                                )
                              })}
                              {tagsData.length > 2 && <Popover activator={<Tag onClick={() => setShowMoreTags((showMoreTags) => showMoreTags === index ? -1 : index)}>+{tagsData.length - 2} more</Tag>} active={showMoreTags === index} onClose={() => setShowMoreTags(-1)}>
                                <Popover.Section>
                                  <BlockStack gap={"200"}>
                                    {tagsData.slice(2).map((ele: string, ind: number) => {
                                      return (
                                        <Tag key={ind}>{ele}</Tag>
                                      )
                                    })}
                                  </BlockStack>
                                </Popover.Section>
                              </Popover>}
                            </BlockStack>
                          </BlockStack>
                        </div>
                        <Text variant="headingXl" as="h5">
                          {amazon_regions.find(a => a?.currency === row?.totalCharge?.unit)?.currency_symbol ?? ''}
                          {row?.totalCharge?.value}
                        </Text>
                      </InlineStack>
                    }
                    checked={selectedOption === (row?.rateId ?? '')}
                    id={`${index}`}
                    name={`${index}`}
                    onChange={() => { setOptionSelected(a => (row?.rateId ?? '')) }}
                    disabled={row?.requiresAdditionalInputs}
                  />
              })}
              <Pagination
                label={`${pagination}/${totalPages}`}
                hasPrevious={pagination > 1}
                onPrevious={() => {
                  setPagination(a => a - 1)
                }}
                hasNext={pagination < (rows.length / itemsPerPage)}
                onNext={() => {
                  setPagination(a => a + 1)
                }}
              />
            </BlockStack>
          </div>}
        </BlockStack>
      </Modal.Section>
    </Modal>
    <InlineStack gap="600" blockAlign='start'>
      {!label_generated && <Button tone={service_selected.error ? "critical" : undefined} variant={service_selected.error ? "primary" : undefined} icon={ShipmentMajor} onClick={() => { getRows() }} loading={loader}>Select Service</Button>}
      {service_selected.rateId && service_selected.requestToken &&
        <BlockStack gap="200">
          <Text variant="headingSm" as="h6">
            {t("Selected service")}
          </Text>
          <InlineStack blockAlign='start' align='space-between'>
            <BlockStack gap="0">
              <Text variant="bodyLg" as="p">
                {selectedRow?.serviceName ?? ''}
              </Text>
              <Text variant="bodySm" as="p" tone='subdued'>
                {t("Carrier ID")}: {selectedRow?.carrierId ?? ''}
              </Text>
            </BlockStack>
            <Text variant="headingXl" as="h4">
              {amazon_regions.find(a => a?.currency === selectedRow?.totalCharge?.unit)?.currency_symbol ?? ''}
              {selectedRow?.totalCharge?.value}
            </Text>
          </InlineStack>
          <BlockStack gap="100">
            <Text variant="headingSm" as="h6">
              {t("Ship By")}:
            </Text>
            <Text as="p" fontWeight="medium" tone="caution">
              {selectedRow?.promise?.pickupWindow?.start ? new Date(selectedRow?.promise?.pickupWindow?.start).toUTCString() : props?.shipDate?.value ? new Date(props?.shipDate?.value).toUTCString() : "N/A"}
              &nbsp;-&nbsp;
              {selectedRow?.promise?.pickupWindow?.end ? new Date(selectedRow?.promise?.pickupWindow?.end).toUTCString() : props?.shipDate?.value ? new Date(props?.shipDate?.value).toUTCString() : "N/A"}
            </Text>
          </BlockStack>
          <BlockStack gap="100">
            <Text variant="headingSm" as="h6">
              {t("Deliver By")}:
            </Text>
            <Text as="p" fontWeight="medium" tone="success">
              {selectedRow?.promise?.deliveryWindow?.start && new Date(selectedRow?.promise?.deliveryWindow?.start).toUTCString()}
              &nbsp;-&nbsp;
              {selectedRow?.promise?.deliveryWindow?.end && new Date(selectedRow?.promise?.deliveryWindow?.end).toUTCString()}
            </Text>
          </BlockStack>
        </BlockStack>}
    </InlineStack>
  </>;
}

export default DI(ShippingServices);